import React from 'react';

import { Paragraph } from '../';

const Disclaimer = ({ children, style }) => {
  return (
    <div style={style} className="disclaimer w__flex w__flex-row">
      <span className="sup">*</span>
      <Paragraph normal color="#1e1e1a">
        {children}
      </Paragraph>
    </div>
  );
};

export default Disclaimer;


// WEBPACK FOOTER //
// ./src/components/theme/Disclaimer/Disclaimer.jsx